export const externalCheck = (link: string): boolean => {
  if(link){
    if ((link.match('http')) || (link.match('mailto')) || (link.match('wpengine'))) {
      return true;
    }
  }
  return false;
};
